// #368: the one place the basemap provider is chosen. Both maps (EventMap,
// EventVenueMap) import from here, so a provider change is a one-line edit.
//
// CARTO's basemaps.cartocdn.com went behind an API key and serves keyless
// callers "API KEY REQUIRED" watermark tiles. OSM's standard raster endpoint
// is keyless; this site's traffic is comfortably within the OSMF tile usage
// policy (https://operations.osmfoundation.org/policies/tiles/). Note the
// endpoint takes no {s} subdomain and no {r} retina suffix.
export const TILE_URL = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png'
export const TILE_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
